module.exports = __webpack_public_path__ + "img/icon_shijianmasel.99efac01.svg";